<template>
  <div :class="{'text-success': value > 0, 'text-danger': value < 0}">
    <span v-if="value !== 0">{{ Math.round(value) }}
      <span v-if="isPercentage">%</span>
    </span>
    <i class="fa" :class="{'fa-level-up': value > 0,
                           'fa-level-down': value < 0,
                           'fa-minus': value === 0}"></i>
  </div>
</template>

<script>
export default {
  name: 'Growth',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    isPercentage: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// Growth.vue?56d9dcf3